import { atom } from "recoil"

export const AtomCurrentBadge4Url = atom({
    key:'ATOMBADGE4URl',
    default:''
})
  